import VectorProps from "./VectorProps";

export default function PercentageIcon(props: VectorProps) {
  const {
    className = "",
    handleClick = () => null,
    height,
    width,
    fill = "currentColor",
  } = props;
  // from https://www.figma.com/file/rLrIcFwMEs8d85RV3WYykA/Foodsteps-2023-Design-Library?type=design&node-id=846-888&mode=design&t=vhCxptW20kMnqOWa-0
  return (
    <svg
      fill={fill}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      height={height ?? width}
      onClick={handleClick}
      width={width}
    >
      <path
        d="M5.51003 7.968C6.54403 7.968 7.18203 7.22 7.18203 5.922C7.18203 4.646 6.54403 3.876 5.51003 3.876C4.47603 3.876 3.81603 4.602 3.81603 5.922C3.81603 7.264 4.47603 7.968 5.51003 7.968ZM5.48803 9.75C3.33203 9.75 1.66003 8.122 1.66003 5.944C1.66003 3.744 3.39803 2.116 5.51003 2.116C7.62204 2.116 9.31603 3.7 9.31603 5.9C9.31603 8.122 7.64403 9.75 5.48803 9.75ZM3.81603 18L13.958 2.27H15.806L5.68603 18H3.81603ZM14.134 16.438C15.168 16.438 15.806 15.69 15.806 14.392C15.806 13.116 15.168 12.346 14.134 12.346C13.1 12.346 12.44 13.072 12.44 14.392C12.44 15.734 13.1 16.438 14.134 16.438ZM14.112 18.22C11.956 18.22 10.306 16.592 10.306 14.414C10.306 12.214 12.022 10.586 14.134 10.586C16.246 10.586 17.962 12.17 17.962 14.37C17.962 16.592 16.268 18.22 14.112 18.22Z"
        fill={fill}
      />
    </svg>
  );
}
